import { render, staticRenderFns } from "./StatsLastReviews.vue?vue&type=template&id=0629b9e8&"
import script from "./StatsLastReviews.vue?vue&type=script&lang=js&"
export * from "./StatsLastReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports